import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  PrintSiteRef,
  CustomerType,
  CheckLayout,
} from '../../core/models/reference.model';

export const ReferenceActions = createActionGroup({
  source: 'Reference',
  events: {
    'Load All Reference Data': emptyProps(),
    'Load Print Sites': emptyProps(),
    'Load Customer Types': emptyProps(),
    'Load Check Layouts': emptyProps(),
  },
});

export const ReferenceAPIActions = createActionGroup({
  source: 'Reference API',
  events: {
    'Load Print Sites Success': props<{ printSites: PrintSiteRef[] }>(),
    'Load Print Sites Failure': props<{ error: string }>(),
    'Load Customer Types Success': props<{ customerTypes: CustomerType[] }>(),
    'Load Customer Types Failure': props<{ error: string }>(),
    'Load Check Layouts Success': props<{ checkLayouts: CheckLayout[] }>(),
    'Load Check Layouts Failure': props<{ error: string }>(),
  },
});
